module.exports = __webpack_public_path__ + "static/media/55_000078.9634cc13.jpg";